// extracted by mini-css-extract-plugin
export default {"autopilotContainer":"Autopilot_autopilotContainer__Ciu4P","title":"Autopilot_title__HXrYk","features":"Autopilot_features__8N+W6"};